export default {
  getThemeName: function () {
    try {
      let localStorageTheme = localStorage && localStorage['ngStorage-integrifyTheme'];
      if (localStorageTheme) { localStorageTheme = localStorageTheme.replace(/"/g, ''); }
      let defaultTheme = localStorage && localStorage.getItem('defaultTheme');
      
      return localStorageTheme || defaultTheme || 'mono-nutrient';
    } catch (e) {
      return 'mono-nutrient';
    }
  },
  /**
   * @returns {Record<string, string> & { baselineUI: {} }}
   */
  getTheme: function() {
    let theme = this.getThemeName();
    return this.getThemes()[theme];
  },
  getThemes: function() {
    /* legacy Vuetify2 defualt theme, it is necessary to redefine terms
    { 
      primary: '#1976D2',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
    }
    */
    return {
      "mono-black": {
        text_primary_color: '#ffffff',
        primary_background_color: '#212121',
        primary_color: '#ffffff',
        secondary_background_color: '#e1f5fe',
        secondary_color: '#000000',
        alt_primary_background_color: '#757575',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#fafafa',
        alt_secondary_color: '#000000',
        section_header_background_color: '#EEEEEE',
        section_items_background_color: '#FAFAFA',
        hover_background_color: '#F5F5F5',
    
        // vuetify built in names
        primary: '#212121',
        secondary: '#e1f5fe',
        accent: '#757575',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      },
      "mono-blue": {
        text_primary_color: '#3949ab',
        primary_background_color: '#3949ab',
        primary_color: '#ffffff',
        secondary_background_color: '#7ac1e2',
        secondary_color: '#000000',
        alt_primary_background_color: '#ef6c00',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#f57c00',
        alt_secondary_color: '#ffffff',
        section_header_background_color: '#90CAF9',
        section_items_background_color: '#E3F2FD',
        hover_background_color: '#BBDEFB',
    
        // vuetify built in names
        primary: '#3949ab',
        secondary: '#7ac1e2',
        accent: '#ef6c00',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      },
      "mono-green": {
        text_primary_color: '#43a047',
        primary_background_color: '#43a047',
        primary_color: '#ffffff',
        secondary_background_color: '#b2f1b7',
        secondary_color: '#000000',
        alt_primary_background_color: '#6a1b9a',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#d77ee7',
        alt_secondary_color: '#ffffff',
        section_header_background_color: '#a5d6a7',
        section_items_background_color: '#e8f5e9',
        hover_background_color: '#C8E6C9',
    
        // vuetify built in names
        primary: '#43a047',
        secondary: '#b2f1b7',
        accent: '#6a1b9a',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      },
      "mono-light-blue": {
        text_primary_color: '#039be5',
        primary_background_color: '#039be5',
        primary_color: '#ffffff',
        secondary_background_color: '#e1f5fe',
        secondary_color: '#000000',
        alt_primary_background_color: '#757575',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#fafafa',
        alt_secondary_color: '#000000',
        section_header_background_color: '#81D4FA',
        section_items_background_color: '#E1F5FE',
        hover_background_color: '#B3E5FC',
    
        // vuetify built in names
        primary: '#039be5',
        secondary: '#e1f5fe',
        accent: '#757575',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      },
      "mono-grey": {
        // v7
        text_primary_color: '#757575',
        primary_background_color: '#757575',
        primary_color: '#ffffff',
        secondary_background_color: '#fafafa',
        secondary_color: '#000000',
        alt_primary_background_color: '#00838f',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#8be4ee',
        alt_secondary_color: '#000000',
        section_header_background_color: '#EEEEEE',
        section_items_background_color: '#FAFAFA',
        hover_background_color: '#F5F5F5',
    
        // vuetify built in names
        primary: '#757575',
        secondary: '#fafafa',
        accent: '#00838f',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      },
      "mono-orange": {
        text_primary_color: '#fb8c00',
        primary_background_color: '#fb8c00',
        primary_color: '#ffffff',
        secondary_background_color: '#f9deb4',
        secondary_color: '#000000',
        alt_primary_background_color: '#00838f',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#8be4ee',
        alt_secondary_color: '#000000',
        section_header_background_color: '#FFCC80',
        section_items_background_color: '#FFF3E0',
        hover_background_color: '#FFE0B2',
    
        // vuetify built in names
        primary: '#fb8c00',
        secondary: '#f9deb4',
        accent: '#00838f',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      },
      "mono-red": {
        text_primary_color: '#e53935',
        primary_background_color: '#e53935',
        primary_color: '#ffffff',
        secondary_background_color: '#f5adb4',
        secondary_color: '#000000',
        alt_primary_background_color: '#00838f',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#8be4ee',
        alt_secondary_color: '#ffffff',
        section_header_background_color: '#EF9A9A',
        section_items_background_color: '#FFEBEE',
        hover_background_color: '#FFCDD2',
    
        // vuetify built in names
        primary: '#e53935',
        secondary: '#f5adb4',
        accent: '#00838f',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',

        baselineUI: {},
      }, 
      "mono-custom": this.getCustom(),
      "mono-nutrient": {
        text_primary_color: '#1A1414',
        primary_background_color: '#1A1414',
        primary_color: '#ffffff',
        secondary_background_color: '#C2B8AE',
        secondary_color: '#000000',
        alt_primary_background_color: '#DE9DCC',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#f57c00',
        alt_secondary_color: '#ffffff',
        section_header_background_color: '#90CAF9',
        section_items_background_color: '#f4f2f1',
        hover_background_color: '#f2f0ee',
    
        // vuetify built in names
        primary: '#1A1414',
        secondary: '#C2B8AE',
        accent: '#DE9DCC',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      },
      "mono-nutrient-yellow": {
        text_primary_color: "#1A1414",
        primary_background_color: "#1A1414",
        primary_color: "#ffffff",
        secondary_background_color: "#C2B8AE",
        secondary_color: "#000000",
        alt_primary_background_color: "#F0C968",
        alt_primary_color: "#ffffff",
        alt_secondary_background_color: "#f57c00",
        alt_secondary_color: "#ffffff",
        section_header_background_color: "#90CAF9",
        section_items_background_color: "#f4f2f1",
        hover_background_color: "#f2f0ee",
        primary: "#1A1414",
        secondary: "#C2B8AE",
        accent: "#F0C968",
        error: "#b71c1c",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00"
    },
      "mono-nutrient-green": {
        text_primary_color: "#1A1414",
        primary_background_color: "#1A1414",
        primary_color: "#ffffff",
        secondary_background_color: "#C2B8AE",
        secondary_color: "#000000",
        alt_primary_background_color: "#6EB579",
        alt_primary_color: "#ffffff",
        alt_secondary_background_color: "#f57c00",
        alt_secondary_color: "#ffffff",
        section_header_background_color: "#90CAF9",
        section_items_background_color: "#f4f2f1",
        hover_background_color: "#f2f0ee",
        primary: "#1A1414",
        secondary: "#C2B8AE",
        accent: "#6EB579",
        error: "#b71c1c",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00"
    },    
      "mono-nutrient-orange": {
        text_primary_color: "#1A1414",
        primary_background_color: "#1A1414",
        primary_color: "#ffffff",
        secondary_background_color: "#C2B8AE",
        secondary_color: "#000000",
        alt_primary_background_color: "#F25E45",
        alt_primary_color: "#ffffff",
        alt_secondary_background_color: "#f57c00",
        alt_secondary_color: "#ffffff",
        section_header_background_color: "#90CAF9",
        section_items_background_color: "#f4f2f1",
        hover_background_color: "#f2f0ee",
        primary: "#1A1414",
        secondary: "#C2B8AE",
        accent: "#F25E45",
        error: "#b71c1c",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00"
      },  
    }
  },
  getCustom: function () {
    let localCustomTheme = localStorage['CustomTheme'];

    if(localCustomTheme) {
      //programmatically blend, lighten, or darken a color
      //https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
      const pSBC=(p,c0,c1,l)=>{
        let r,g,b,P,f,t,h,i=parseInt,m=Math.round,a=typeof(c1)=="string";
        if(typeof(p)!="number"||p<-1||p>1||typeof(c0)!="string"||(c0[0]!='r'&&c0[0]!='#')||(c1&&!a))return null;
        if(!this.pSBCr)this.pSBCr=(d)=>{
            let n=d.length,x={};
            if(n>9){
                [r,g,b,a]=d=d.split(","),n=d.length;
                if(n<3||n>4)return null;
                x.r=i(r[3]=="a"?r.slice(5):r.slice(4)),x.g=i(g),x.b=i(b),x.a=a?parseFloat(a):-1
            }else{
                if(n==8||n==6||n<4)return null;
                if(n<6)d="#"+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(n>4?d[4]+d[4]:"");
                d=i(d.slice(1),16);
                if(n==9||n==5)x.r=d>>24&255,x.g=d>>16&255,x.b=d>>8&255,x.a=m((d&255)/0.255)/1000;
                else x.r=d>>16,x.g=d>>8&255,x.b=d&255,x.a=-1
            }return x};
        h=c0.length>9,h=a?c1.length>9?true:c1=="c"?!h:false:h,f=this.pSBCr(c0),P=p<0,t=c1&&c1!="c"?this.pSBCr(c1):P?{r:0,g:0,b:0,a:-1}:{r:255,g:255,b:255,a:-1},p=P?p*-1:p,P=1-p;
        if(!f||!t)return null;
        if(l)r=m(P*f.r+p*t.r),g=m(P*f.g+p*t.g),b=m(P*f.b+p*t.b);
        else r=m((P*f.r**2+p*t.r**2)**0.5),g=m((P*f.g**2+p*t.g**2)**0.5),b=m((P*f.b**2+p*t.b**2)**0.5);
        a=f.a,t=t.a,f=a>=0||t>=0,a=f?a<0?t:t<0?a:a*P+t*p:0;
        if(h)return"rgb"+(f?"a(":"(")+r+","+g+","+b+(f?","+m(a*1000)/1000:"")+")";
        else return"#"+(4294967296+r*16777216+g*65536+b*256+(f?m(a*255):0)).toString(16).slice(1,f?undefined:-2)
      }
      const customTheme = JSON.parse(localCustomTheme);
      const { primary, secondary, accent} = customTheme;

      let ret = {
         text_primary_color: primary,
        primary_background_color: primary,
         primary_color: '#ffffff',
         secondary_background_color: secondary,
         secondary_color: '#000000',
         alt_primary_background_color: accent,
         alt_primary_color: '#ffffff',
         alt_secondary_background_color: '#f57c00',
         alt_secondary_color: '#ffffff',
         section_header_background_color: '#90CAF9',
        section_items_background_color: pSBC(-0.8, secondary, '#FFFFFF'),
        hover_background_color: pSBC(-0.76, secondary, '#FFFFFF'),

        // vuetify built in names
        primary: primary,
        secondary: secondary,
        accent: accent,
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      }
      
      return ret
    }

    //mono-blue
    return {
        text_primary_color: '#3949ab',
        primary_background_color: '#3949ab',
        primary_color: '#ffffff',
        secondary_background_color: '#7ac1e2',
        secondary_color: '#000000',
        alt_primary_background_color: '#ef6c00',
        alt_primary_color: '#ffffff',
        alt_secondary_background_color: '#f57c00',
        alt_secondary_color: '#ffffff',
        section_header_background_color: '#90CAF9',
        section_items_background_color: '#E3F2FD',
        hover_background_color: '#BBDEFB',
    
        // vuetify built in names
        primary: '#3949ab',
        secondary: '#7ac1e2',
        accent: '#ef6c00',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00',
      }
    },
};
